"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNonImpersonatingToken = exports.getImpersonatorBearerToken = exports.deleteImpersonation = exports.setImpersonation = exports.getImpersonationDetails = exports.getAuthorizationHeader = exports.getBearer = exports.removeToken = exports.setToken = exports.getToken = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var user_session_1 = require("./user-session");
var cookieKey = "WARDEN_SSO_AUTHORIZATION";
var impersonationKey = "IMPERSONATION";
function getToken() {
    return js_cookie_1.default.get(cookieKey);
}
exports.getToken = getToken;
function getAuthorizationHeader(token) {
    if (token === void 0) { token = getToken(); }
    return {
        Authorization: getBearer(token)
    };
}
exports.getAuthorizationHeader = getAuthorizationHeader;
function getBearer(token) {
    if (token === void 0) { token = getToken(); }
    return "Bearer " + token;
}
exports.getBearer = getBearer;
function setToken(token) {
    js_cookie_1.default.set(cookieKey, token, { path: "/" });
}
exports.setToken = setToken;
function removeToken() {
    js_cookie_1.default.remove(cookieKey, { path: "/" });
}
exports.removeToken = removeToken;
function setImpersonation(token) {
    var _a, _b, _c, _d;
    var impersonationDetails = {
        originalTenant: (_a = token === null || token === void 0 ? void 0 : token.entity) === null || _a === void 0 ? void 0 : _a.managedBy,
        impersonatedTenant: (_b = token === null || token === void 0 ? void 0 : token.entity) === null || _b === void 0 ? void 0 : _b.tenantKey,
        originalToken: getToken()
    };
    js_cookie_1.default.set(impersonationKey, JSON.stringify(impersonationDetails));
    setToken((_c = token === null || token === void 0 ? void 0 : token.grant) === null || _c === void 0 ? void 0 : _c.token);
    user_session_1.setOrganization((_d = token === null || token === void 0 ? void 0 : token.entity) === null || _d === void 0 ? void 0 : _d.tenantKey);
}
exports.setImpersonation = setImpersonation;
function getImpersonationDetails() {
    var impersonationCookie = js_cookie_1.default.get(impersonationKey);
    return !!impersonationCookie ? JSON.parse(impersonationCookie) : undefined;
}
exports.getImpersonationDetails = getImpersonationDetails;
function getImpersonatorBearerToken() {
    var _a;
    return (_a = getImpersonationDetails()) === null || _a === void 0 ? void 0 : _a.originalToken;
}
exports.getImpersonatorBearerToken = getImpersonatorBearerToken;
// get top level token: original user or impersonator (but not the impersonated token)
function getNonImpersonatingToken() {
    var _a, _b;
    return (_b = (_a = getImpersonationDetails()) === null || _a === void 0 ? void 0 : _a.originalToken) !== null && _b !== void 0 ? _b : getToken();
}
exports.getNonImpersonatingToken = getNonImpersonatingToken;
function deleteImpersonation() {
    var impersonationData = getImpersonationDetails();
    if (!!impersonationData) {
        // restore original token and organization details, otherwise the user will be prompted to login
        setToken(impersonationData.originalToken);
        user_session_1.setOrganization(impersonationData.originalTenant);
        js_cookie_1.default.remove(impersonationKey);
    }
}
exports.deleteImpersonation = deleteImpersonation;
